var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M161.067,86.4c0,0,49.067-22.4,49.067-59.733C210.133,11.733,198.4,0,184.533,0 c-10.667,0-19.2,6.4-23.467,14.933C156.8,6.4,147.2,0,137.6,0C122.667,0,112,11.733,112,26.667 C110.933,64,161.067,86.4,161.067,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M403.2,174.933c0,0,30.933-13.867,30.933-37.333c0-9.6-7.467-16-16-16 c-6.4,0-11.733,4.267-14.933,9.6c-2.133-5.333-8.533-9.6-14.933-9.6c-8.533,0-16,7.467-16,16 C372.267,161.067,403.2,174.933,403.2,174.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M139.733,154.667c0,0,17.067-28.8,4.267-48c-5.333-7.467-14.933-9.6-22.4-4.267 c-5.333,3.2-7.467,9.6-6.4,16c-5.333-3.2-11.733-3.2-17.067,1.067c-7.467,5.333-9.6,14.933-4.267,22.4 C105.6,161.067,139.733,154.667,139.733,154.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M234.667,105.6c0,0,20.267-9.6,20.267-24.533c0-6.4-5.333-10.667-10.667-10.667 c-4.267,0-7.467,2.133-9.6,6.4c-2.133-3.2-5.333-6.4-9.6-6.4c-6.4,0-10.667,5.333-10.667,10.667 C214.4,96,234.667,105.6,234.667,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M331.733,174.933c0,0,20.267-9.6,20.267-24.533c0-6.4-5.333-10.667-10.667-10.667 c-4.267,0-7.467,2.133-9.6,6.4c-2.133-3.2-5.333-6.4-9.6-6.4c-6.4,0-10.667,5.333-10.667,10.667 C311.467,165.333,331.733,174.933,331.733,174.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M294.4,101.333c0,0,43.733,0,56.533-27.733c5.333-10.667,0-23.467-10.667-27.733 c-7.467-3.2-16-2.133-22.4,3.2c0-7.467-4.267-14.933-11.733-19.2c-10.667-5.333-23.467,0-27.733,10.667 C265.6,68.267,294.4,101.333,294.4,101.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M245.333,211.2c0,0,29.867-37.333,13.867-66.133c-5.333-11.733-19.2-16-30.933-9.6 c-7.467,4.267-12.8,12.8-11.733,21.333c-6.4-5.333-16-6.4-24.533-2.133c-10.667,5.333-16,19.2-9.6,30.933 C197.333,213.333,245.333,211.2,245.333,211.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.533,
    y: 185.6,
    style: {
      fill: "#FFD15C"
    },
    width: 365.867,
    height: 326.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,462.933 371.2,488.533 342.4,462.933 313.6,488.533 284.8,462.933 256,488.533  227.2,462.933 198.4,488.533 169.6,462.933 140.8,488.533 112,462.933 83.2,488.533 72.533,478.933 72.533,485.333 83.2,496  112,469.333 140.8,496 169.6,469.333 198.4,496 227.2,469.333 256,496 284.8,469.333 313.6,496 342.4,469.333 371.2,496  400,469.333 428.8,496 439.467,485.333 439.467,478.933 428.8,488.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,424.533 371.2,451.2 342.4,424.533 313.6,451.2 284.8,424.533 256,451.2 227.2,424.533  198.4,451.2 169.6,424.533 140.8,451.2 112,424.533 83.2,451.2 72.533,441.6 72.533,448 83.2,457.6 112,432 140.8,457.6 169.6,432  198.4,457.6 227.2,432 256,457.6 284.8,432 313.6,457.6 342.4,432 371.2,457.6 400,432 428.8,457.6 439.467,448 439.467,441.6  428.8,451.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,387.2 371.2,413.867 342.4,387.2 313.6,413.867 284.8,387.2 256,413.867 227.2,387.2  198.4,413.867 169.6,387.2 140.8,413.867 112,387.2 83.2,413.867 72.533,403.2 72.533,410.667 83.2,420.267 112,393.6  140.8,420.267 169.6,393.6 198.4,420.267 227.2,393.6 256,420.267 284.8,393.6 313.6,420.267 342.4,393.6 371.2,420.267 400,393.6  428.8,420.267 439.467,410.667 439.467,403.2 428.8,413.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,348.8 371.2,375.467 342.4,348.8 313.6,375.467 284.8,348.8 256,375.467 227.2,348.8  198.4,375.467 169.6,348.8 140.8,375.467 112,348.8 83.2,375.467 72.533,365.867 72.533,372.267 83.2,381.867 112,356.267  140.8,381.867 169.6,356.267 198.4,381.867 227.2,356.267 256,381.867 284.8,356.267 313.6,381.867 342.4,356.267 371.2,381.867  400,356.267 428.8,381.867 439.467,372.267 439.467,365.867 428.8,375.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,311.467 371.2,338.133 342.4,311.467 313.6,338.133 284.8,311.467 256,338.133  227.2,311.467 198.4,338.133 169.6,311.467 140.8,338.133 112,311.467 83.2,338.133 72.533,327.467 72.533,334.933 83.2,344.533  112,317.867 140.8,344.533 169.6,317.867 198.4,344.533 227.2,317.867 256,344.533 284.8,317.867 313.6,344.533 342.4,317.867  371.2,344.533 400,317.867 428.8,344.533 439.467,334.933 439.467,327.467 428.8,338.133  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,274.133 371.2,299.733 342.4,274.133 313.6,299.733 284.8,274.133 256,299.733  227.2,274.133 198.4,299.733 169.6,274.133 140.8,299.733 112,274.133 83.2,299.733 72.533,290.133 72.533,296.533 83.2,306.133  112,280.533 140.8,306.133 169.6,280.533 198.4,306.133 227.2,280.533 256,306.133 284.8,280.533 313.6,306.133 342.4,280.533  371.2,306.133 400,280.533 428.8,306.133 439.467,296.533 439.467,290.133 428.8,299.733  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,235.733 371.2,262.4 342.4,235.733 313.6,262.4 284.8,235.733 256,262.4 227.2,235.733  198.4,262.4 169.6,235.733 140.8,262.4 112,235.733 83.2,262.4 72.533,252.8 72.533,259.2 83.2,268.8 112,242.133 140.8,268.8  169.6,242.133 198.4,268.8 227.2,242.133 256,268.8 284.8,242.133 313.6,268.8 342.4,242.133 371.2,268.8 400,242.133 428.8,268.8  439.467,259.2 439.467,252.8 428.8,262.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7B64C"
    },
    points: "400,198.4 371.2,224 342.4,198.4 313.6,224 284.8,198.4 256,224 227.2,198.4 198.4,224  169.6,198.4 140.8,224 112,198.4 83.2,224 72.533,214.4 72.533,220.8 83.2,231.467 112,204.8 140.8,231.467 169.6,204.8  198.4,231.467 227.2,204.8 256,231.467 284.8,204.8 313.6,231.467 342.4,204.8 371.2,231.467 400,204.8 428.8,231.467  439.467,220.8 439.467,214.4 428.8,224  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#415A6B"
    },
    cx: 180.267,
    cy: 246.4,
    r: 17.067
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#415A6B"
    },
    cx: 331.733,
    cy: 246.4,
    r: 17.067
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M256,417.067c-45.867,0-82.133-74.667-82.133-170.667c0-3.2,3.2-6.4,6.4-6.4c3.2,0,6.4,3.2,6.4,6.4 c0,85.333,32,157.867,69.333,157.867s69.333-72.533,69.333-157.867c0-3.2,3.2-6.4,6.4-6.4c3.2,0,6.4,3.2,6.4,6.4 C338.133,342.4,301.867,417.067,256,417.067z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shoppingIcon.ea69f2d725b8b26bd64e496689fd3b82.svg";
export { ForwardRef as ReactComponent };